import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { ContactFragments } from '../../graphql/contact.graphql';
import { Contact } from '../../types/contact';
import { useAppDispatch } from '../../ui/pages/store';
import { contactSlice } from '../../providers/ContactProvider';

const contactSubscription = gql`
  subscription contactNotification($companyId: String!) {
    contactNotification(companyId: $companyId) {
      companyId
      entities {
        ...Contact
      }
      topic
      date
    }
  }
  ${ContactFragments.contact}
`;

export class ContactNotificationResponse extends forNotification<Contact>('contactNotification') {}

export default function ContactNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: contactNotifaction } = useSubscription<ContactNotificationResponse>(contactSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleContactNotification = (notification?: ContactNotificationResponse) => {
    if (!notification?.contactNotification) return;
    const contactNotification = notification.contactNotification;

    switch (contactNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(contactSlice.actions.add(contactNotification.entities));
        break;
      case 'DELETE':
        dispatch(contactSlice.actions.delete(contactNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleContactNotification(contactNotifaction);
  }, [contactNotifaction]);

  return <></>;
}
